module.exports = __webpack_public_path__ + "static/bottom-dee090f49fdb6d3a16ddead0a5a61bf9.png";